import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class AnotacoesService {


  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getAnotations(
    pageIndex: number,
    contract_id: any,
    sortDirection?: string,
    sortProperty?: string,
    descricao?: string,
    data?: any,
    usuario?: string,
  ) {

    const params = new HttpParams().set('page', pageIndex?.toString() || '0')
      .set('size', '10')
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('descricao', descricao || '')
      .set('data', data || '')
      .set('usuario', usuario || '')

    return this.http.get(this.baseUrl + `/v1/contratos/${contract_id}/anotacoes`, { params })
  }

  postAnotation(contractId: any, data: any) {

    const headers = new HttpHeaders({
      'Usuario-Criacao': "usuarioCriacao"
    });
    return this.http.post(this.baseUrl + `/v1/contratos/${contractId}/anotacoes`, { ...data }, { headers })
  }
  putAnotation(contractId: any, noteId: any, data: any) {
    const headers = new HttpHeaders({
      'Usuario-Criacao': "usuarioCriacao"
    });
    return this.http.put(this.baseUrl + `/v1/contratos/${contractId}/anotacoes/${noteId}`, { ...data }, { headers })
  }
  deleteAnotation(contractId: any, noteId: any) {
    return this.http.delete(this.baseUrl + `/v1/contratos/${contractId}/anotacoes/${noteId}`,)
  }
  getHistoryAnotacao(contractId: string | null,  entitieId: string | null, pageIndex:number = 0){
    return this.http.get(this.baseUrl + `/v1/contratos/${contractId}/anotacoes/${entitieId}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`);
  }
}
